import { createEventDefinition, EventBus as TsBus } from "ts-bus";
export default class EventBus {
    bus = new TsBus();
    subscribe(subscription, handler) {
        const unsubscribe = this.bus.subscribe(subscription, handler);
        return { dispose: unsubscribe };
    }
    subscribeAll(handler) {
        return this.subscribe("**", handler);
    }
    publish(event, payloadOrMeta) {
        if (typeof event === "string") {
            this.bus.publish({
                type: event,
                payload: payloadOrMeta,
            });
        }
        else {
            this.bus.publish(event, payloadOrMeta);
        }
    }
}
export { createEventDefinition };
//# sourceMappingURL=eventBus.js.map